export * from './dashboard.component';


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/dashboard/index.ts